import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-incoming-call-toast',
  standalone: true,
  imports: [ToastModule, LocalizationPipe],
  templateUrl: './incoming-call-toast.component.html',
  styleUrl: './incoming-call-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncomingCallToastComponent {
  readonly ringtoneMuted = input(false);
  readonly toastAnswering = input(false);
  readonly callerName = input<string | null>(null);
  readonly callerSummary = input<string | null>(null);
  readonly callerDetail = input<string | null>(null);
  readonly queueName = input<string | null>(null);
  /** Name of the agent who transferred this call; null for ordinary calls. */
  readonly transferFromAgentName = input<string | null>(null);
  /** Queue the caller had reached before being transferred; null for ordinary calls. */
  readonly transferFromQueueName = input<string | null>(null);

  readonly badgeQueueName = computed(() => this.queueName() ?? this.transferFromQueueName());

  readonly originQueueName = computed(() => {
    const origin = this.transferFromQueueName();
    return origin && origin !== this.badgeQueueName() ? origin : null;
  });

  readonly answer = output<void>();
  readonly reject = output<void>();
  readonly muteToggle = output<void>();

  onAnswer(): void {
    this.answer.emit();
  }

  onReject(): void {
    this.reject.emit();
  }

  onMuteToggle(): void {
    this.muteToggle.emit();
  }
}
